export function toError(reason, fallbackMessage) {
    if (reason instanceof Error) {
        return reason;
    }
    if (typeof reason === 'string' && reason) {
        return new Error(reason);
    }
    return new Error(fallbackMessage);
}
